<template>
  <div class="sidebar d-flex flex-column flex-shrink-0 d-print-none" :class="{open: open}" id="accordionSidebar">
    <div v-if="userStore.isImpersonating" class="sidebar-impersonation-alert">
      <div class="sidebar-impersonation-alert__header">
        <Icon icon="fa-pro-solid:user-secret" />
        <span>Impersonation active</span>
      </div>
      <div class="sidebar-impersonation-alert__target">
        {{ impersonationTargetName }}
      </div>
      <div class="sidebar-impersonation-alert__meta">
        Original user: {{ originalStaffName }}
      </div>
    </div>
    <div class="nav-group" :class="{ account: group.account }" :key="index"
         v-for="(group, index) in menuItems">
      <h4 v-if="group.header" class="mt-3 d-flex">{{ group.header }}</h4>
      <ul class="nav flex-column mb-auto  w-100">
        <template :key="index2" v-for="(item2, index2) in group.children">
          <template v-if="!item2.hide">
            <router-link :to="resolveItemRoute(item2)"
                         custom
                         v-slot="{ href, navigate, isActive, isExactActive }">
              <li :class="[
                   'w-100',
                'nav-item',
                'nav-lvl2',
                'position-relative',
                isActive && 'nav-item-active',
                isExactActive && 'nav-item-exact-active',
             ]">
                <a :href="href" @click.prevent="handleNavigation(navigate, item2, group)" :class="[
                'nav-link',
                'position-relative',
                getBaseTypeThemeClass(item2),
                item2.highlight && 'sidebar-link-highlight',
                (index !== 'account') && 'text-uppercase',
                isItemDisabled(item2, group) && 'sidebar-link-disabled',
                isItemDisabled(item2, group) && 'sidebar-link-disabled-visual',
             ]" :style="getBaseTypeThemeStyle(item2)">
                  <span v-if="item2.highlight" class="sidebar-link-stars" aria-hidden="true">
                    <span class="sidebar-link-stars__layer sidebar-link-stars__layer--fast"></span>
                    <span class="sidebar-link-stars__layer sidebar-link-stars__layer--reverse"></span>
                    <span class="sidebar-link-stars__layer sidebar-link-stars__layer--slow"></span>
                  </span>
                  <span class="sidebar-link-main">
                    <span class="sidebar-link-icon">
                      <Icon :icon="item2.icon"/>
                    </span>
                    <span class="sidebar-link-label text-truncate">{{ item2.name }}</span>
                    <Icon
                      v-if="showAttentionWarning(item2)"
                      icon="fa-pro-solid:triangle-exclamation"
                      class="ms-2 text-warning flex-shrink-0"
                    />
                  </span>
                  <Icon
                    v-if="item2.noticeIcon"
                    :icon="item2.noticeIcon"
                    class="sidebar-link-notice"
                    title="Neue Anfragen"
                    aria-label="Neue Anfragen"
                    data-test="sidebar-notice-icon"
                  />
                  <Icon icon="fa-pro-solid:chevron-right" class="ms-auto" />
                </a>
                <button
                  v-if="showDisabledHint(item2)"
                  type="button"
                  class="sidebar-link-hint-btn sidebar-link-hint-btn--overlay"
                  title="Passendes Paket ansehen"
                  @click.stop.prevent="goToDisabledHint(item2)"
                >
                  <span class="sidebar-link-hint-rocket" :class="{'sidebar-link-hint-rocket--launch': isHintLaunching(item2)}">
                    <Icon icon="streamline-ultimate:startup-product-rocket-box-bold" />
                  </span>
                </button>
                <ul v-if="item2.children" class="nav flex-column mb-auto w-100" :class="{'d-none': !isActive}">
                  <li class="nav-item nav-lvl3 w-100 position-relative" :key="index3" v-for="(item3, index3) in item2.children">
                    <template v-if="!item3.hide">
                      <router-link :to="resolveItemRoute(item3)"
                                   custom
                                   v-slot="{ href, navigate }">
                        <a :href="href"
                           :class="{  'nav-link': true,
                                        'w-100': true,
                                        'py-2': true,
                                        'text-truncate': true,
                                        [getBaseTypeThemeClass(item3)]: true,
                                        'sidebar-link-disabled': isItemDisabled(item3, item2, group),
                                        'sidebar-link-disabled-visual': isItemDisabled(item3, item2, group),
                                     }"
                           :style="getBaseTypeThemeStyle(item3)"
                           @click.prevent="handleNavigation(navigate, item3, item2, group)">
                          <span class="sidebar-link-main">
                            <span class="sidebar-link-icon">
                              <Icon :icon="fa2iconify(item3.icon)"/>
                            </span>
                            <span class="sidebar-link-label text-truncate">{{ item3.name }}</span>
                            <Icon
                              v-if="showAttentionWarning(item3)"
                              icon="fa-pro-solid:triangle-exclamation"
                              class="ms-2 text-warning flex-shrink-0"
                            />
                          </span>
                        </a>
                        <button
                          v-if="showDisabledHint(item3)"
                          type="button"
                          class="sidebar-link-hint-btn sidebar-link-hint-btn--nested"
                          title="Passendes Paket ansehen"
                          @click.stop.prevent="goToDisabledHint(item3)"
                        >
                          <span class="sidebar-link-hint-rocket" :class="{'sidebar-link-hint-rocket--launch': isHintLaunching(item3)}">
                            <Icon icon="streamline-ultimate:startup-product-rocket-box-bold" />
                          </span>
                        </button>
                      </router-link>
                    </template>

                    <ul v-if="item3.children" class="nav flex-column mb-auto">
                      <li class="nav-item nav-lvl4" :key="index4" v-for="(item4, index4) in item3.children">
                        <template v-if="item4.active !== false">
                          <router-link :to="resolveItemRoute(item4)"
                                       custom
                                       v-slot="{ href, navigate }">
                            <a :href="href"
                                      :class="{
                                            'nav-link': true,
                                            'py-2': true,
                                            'py-lg-1': true,
                                            [getBaseTypeThemeClass(item4)]: true,
                                            'sidebar-link-disabled': isItemDisabled(item4, item3, item2, group),
                                            'opacity-25': isItemDisabled(item4, item3, item2, group)
                                        }"
                                       :style="getBaseTypeThemeStyle(item4)"
                                       @click.prevent="handleNavigation(navigate, item4, item3, item2, group)">
                              <span class="sidebar-link-main">
                                <span class="sidebar-link-icon">
                                  <Icon :icon="fa2iconify(item4.icon) || 'fas fa-question-circle'"/>
                                </span>
                                <span class="sidebar-link-label text-truncate">{{ item4.name }}</span>
                              </span>
                            </a>
                          </router-link>
                        </template>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
            </router-link>
          </template>
        </template>
      </ul>
    </div>
    <div class="sidebar-session mt-auto pt-3">
      Logout: {{ logoutTime }}
    </div>
  </div>
</template>

<script>
import {useUserStore} from "@/stores/user";
import {getBaseTypeThemeClass, getBaseTypeThemeStyle, resolveBaseTypeKey} from "@/utils/baseTypeTheme";
const FONTAWESOME_MAP = {
  fas: 'fa-pro-solid',
}
const STAR_RAIN_FRAME_INTERVAL_MS = 1000 / 30
const STAR_RAIN_TRAVEL_PX = 88
const STAR_RAIN_LAYER_CONFIGS = [
  {property: '--star-rain-fast', duration: 3800, reverse: false},
  {property: '--star-rain-reverse', duration: 5400, reverse: true},
  {property: '--star-rain-slow', duration: 6800, reverse: false},
]

export default {
  name: "Sidebar",
  setup() {
    const userStore = useUserStore()
    return {
      userStore,
    }
  },
  data() {
    return {
      launchingHintKey: null,
      starRainStartedAt: 0,
      starRainTimer: null,
    }
  },
  mounted() {
    this.startStarRain()
  },
  beforeUnmount() {
    this.stopStarRain()
  },
  props: {
    open: Boolean,
    isMobile: Boolean
  },
  watch: {
    open() {
      this.syncStarRain()
    },
    hasHighlightedItems() {
      this.syncStarRain()
    },
  },
  computed: {
    hasHighlightedItems() {
      // Both menu groups and their children are keyed objects, not arrays.
      return Object.values(this.menuItems).some(
        (group) => Object.values(group?.children || {}).some((item) => item?.highlight && !item?.hide)
      )
    },
    statistics() {
      return this.userStore.user.stats;
    },
    user() {
      return this.userStore.user;
    },
    menuItems() {
      const user = this.user
      const menu = Object.assign({}, user.getCustomerMenuItems());
      return menu;
    },
    logoutTime() {
      if (!this.user?.exp) {
        return '-'
      }

      return new Date(Number(this.user.exp) * 1000).toLocaleTimeString('de-DE', {
        hour: '2-digit',
        minute: '2-digit',
      })
    },
    impersonationTargetName() {
      const client = this.userStore.impersonation?.target?.client
      const targetUser = this.userStore.impersonation?.target?.user
      const clientLabel = client?.name && client?.kdnr ? `${client.name} (${client.kdnr})` : client?.name
      const userLabel = this.formatPerson(targetUser)

      return clientLabel || userLabel || 'Customer view'
    },
    originalStaffName() {
      return this.formatPerson(this.userStore.impersonation?.impersonator) || 'MANET'
    }
  },
  methods: {
    startStarRain() {
      this.starRainStartedAt = performance.now()
      document.addEventListener('visibilitychange', this.syncStarRain)
      this.syncStarRain()
    },
    stopStarRain() {
      this.pauseStarRain()
      document.removeEventListener('visibilitychange', this.syncStarRain)
    },
    // The rain only needs to advance while it can actually be seen: the tab is
    // visible, the sidebar is expanded and at least one link is highlighted.
    shouldStarRainRun() {
      return !document.hidden && this.open && this.hasHighlightedItems
    },
    syncStarRain() {
      if (this.shouldStarRainRun()) {
        this.resumeStarRain()
        return
      }

      this.pauseStarRain()
    },
    pauseStarRain() {
      if (this.starRainTimer === null) {
        return
      }

      window.clearInterval(this.starRainTimer)
      this.starRainTimer = null
    },
    resumeStarRain() {
      if (this.starRainTimer !== null) {
        return
      }

      this.renderStarRainFrame(performance.now())
      this.starRainTimer = window.setInterval(
        () => this.renderStarRainFrame(performance.now()),
        STAR_RAIN_FRAME_INTERVAL_MS
      )
    },
    // Offsets are published as custom properties on the sidebar root and read
    // back by the layers in CSS, so the cost per frame is three property writes
    // regardless of how many highlighted links are rendered, and no element
    // references are held that could go stale when the menu re-renders.
    renderStarRainFrame(now) {
      const elapsed = now - this.starRainStartedAt
      const style = this.$el.style

      STAR_RAIN_LAYER_CONFIGS.forEach(({property, duration, reverse}) => {
        const progress = (elapsed % duration) / duration
        const offset = (reverse ? 1 - progress : progress) * STAR_RAIN_TRAVEL_PX
        style.setProperty(property, `${offset.toFixed(2)}px`)
      })
    },
    formatPerson(person) {
      if (!person) {
        return ''
      }

      return `${person.first_name || ''} ${person.last_name || ''}`.trim() || person.email || ''
    },
    handleClick() {
      if (this.isMobile) {
        this.$emit('closeSidebar')
      }
      return true;
    },
    handleNavigation(navigate, ...items) {
      if (this.isItemDisabled(...items)) {
        return false
      }
      navigate()
      return this.handleClick()
    },
    isItemDisabled(...items) {
      return items.some((item) => item?.disabled)
    },
    resolveItemRoute(item) {
      return typeof(item.route) === 'string' ? {name: item.route} : item.route
    },
    showAttentionWarning(item) {
      return this.user.needsAttention(item?.route)
    },
    showDisabledHint(item) {
      return item?.disabled && item?.disabledHintRoute
    },
    goToDisabledHint(item) {
      if (!item?.disabledHintRoute) {
        return
      }

      const hintKey = this.getHintKey(item)
      this.launchingHintKey = hintKey

      window.setTimeout(() => {
        if (this.launchingHintKey === hintKey) {
          this.launchingHintKey = null
        }
      }, 650)

      window.setTimeout(() => {
        this.$router.push({name: item.disabledHintRoute})
        this.handleClick()
      }, 220)
    },
    getHintKey(item) {
      return `${item?.route || 'unknown'}:${item?.disabledHintRoute || 'unknown'}`
    },
    isHintLaunching(item) {
      return this.launchingHintKey === this.getHintKey(item)
    },
    getBaseTypeThemeClass(item) {
      const baseType = this.getItemBaseType(item)
      return baseType ? getBaseTypeThemeClass(baseType) : ''
    },
    getBaseTypeThemeStyle(item) {
      const baseType = this.getItemBaseType(item)
      return baseType ? getBaseTypeThemeStyle(baseType) : {}
    },
    getItemBaseType(item) {
      const route = typeof item?.route === 'string' ? item.route : item?.route?.name
      const baseType = item?.baseType || item?.base_type

      if (baseType) {
        return resolveBaseTypeKey(baseType)
      }

      if (['accommodations.index', 'offers.index', 'events.index', 'discover.index'].includes(route)) {
        return resolveBaseTypeKey(route)
      }

      return null
    },
    fa2iconify(value) {
      if (Array.isArray(value)) {
        return value.map(item => FONTAWESOME_MAP[item] || item.replace('fa-', '') ).join(':')
      }
      return value
    }

  }
}
</script>

<style scoped lang="scss">
.sidebar-impersonation-alert {
  margin: 0.9rem 0.85rem 0.35rem;
  padding: 0.9rem;
  border: 2px solid #ffce55;
  background:
    linear-gradient(135deg, rgba(255, 206, 85, 0.22), rgba(202, 45, 45, 0.2)),
    #781d1d;
  color: #fff;
  box-shadow: 0 12px 28px rgba(36, 11, 11, 0.42);
}

.sidebar-impersonation-alert__header {
  display: flex;
  align-items: center;
  gap: 0.45rem;
  font-size: 0.78rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.sidebar-impersonation-alert__target {
  margin-top: 0.45rem;
  font-size: 1rem;
  font-weight: 800;
  line-height: 1.18;
  overflow-wrap: anywhere;
}

.sidebar-impersonation-alert__meta {
  margin-top: 0.5rem;
  color: rgba(255, 248, 223, 0.88);
  font-size: 0.78rem;
  line-height: 1.25;
  overflow-wrap: anywhere;
}

.sidebar-link-highlight {
  overflow: hidden;
  contain: paint;
  background:
    linear-gradient(135deg, rgba(246, 193, 95, 0.34), rgba(240, 154, 62, 0.16)),
    #10314d;
  border: 1px solid rgba(246, 193, 95, 0.38);
  box-shadow: 0 10px 24px rgba(12, 31, 48, 0.22);
}

@property --star-rain-fast {
  syntax: "<length>";
  inherits: true;
  initial-value: 0px;
}

@property --star-rain-reverse {
  syntax: "<length>";
  inherits: true;
  initial-value: 88px;
}

@property --star-rain-slow {
  syntax: "<length>";
  inherits: true;
  initial-value: 0px;
}

.sidebar-link-stars {
  position: absolute;
  inset: 0;
  pointer-events: none;
}

.sidebar-link-stars__layer {
  position: absolute;
  inset: -88px 0 0;
  background-repeat: repeat-y;
  background-size: 100% 88px;
  background-position: 0 0;
  opacity: 0.92;
  backface-visibility: hidden;
  will-change: transform;
}

.sidebar-link-stars__layer--fast {
  background-image:
    radial-gradient(circle at 12% 10%, rgba(255, 244, 198, 0.98) 0 1.6px, transparent 2.6px),
    radial-gradient(circle at 38% 28%, rgba(255, 244, 198, 0.94) 0 1.8px, transparent 2.9px),
    radial-gradient(circle at 66% 18%, rgba(255, 231, 161, 0.98) 0 1.5px, transparent 2.5px),
    radial-gradient(circle at 84% 34%, rgba(255, 244, 198, 0.94) 0 1.7px, transparent 2.8px);
  transform: translate3d(0, var(--star-rain-fast, 0px), 0);
}

.sidebar-link-stars__layer--reverse {
  background-image:
    radial-gradient(circle at 20% 16%, rgba(255, 244, 198, 0.72) 0 1.2px, transparent 2.1px),
    radial-gradient(circle at 52% 24%, rgba(255, 244, 198, 0.76) 0 1.4px, transparent 2.2px),
    radial-gradient(circle at 76% 12%, rgba(255, 231, 161, 0.72) 0 1.2px, transparent 2.1px);
  transform: translate3d(0, var(--star-rain-reverse, 88px), 0);
}

.sidebar-link-stars__layer--slow {
  background-image:
    radial-gradient(circle at 8% 30%, rgba(255, 255, 255, 0.62) 0 1px, transparent 1.8px),
    radial-gradient(circle at 44% 8%, rgba(255, 244, 198, 0.68) 0 1.1px, transparent 1.9px),
    radial-gradient(circle at 72% 26%, rgba(255, 255, 255, 0.58) 0 1px, transparent 1.8px),
    radial-gradient(circle at 92% 14%, rgba(255, 231, 161, 0.62) 0 1.1px, transparent 1.9px);
  transform: translate3d(0, var(--star-rain-slow, 0px), 0);
}

.sidebar-link-main {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
  position: relative;
  z-index: 1;
}

.sidebar-link-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.5rem;
  margin-right: 0.25rem;
  flex-shrink: 0;
}

.sidebar-link-label {
  min-width: 0;
}

/* The envelope follows the link color; only the clarity badge dot carries the accent. */
.sidebar-link-notice {
  flex-shrink: 0;
  margin-left: 0.5rem;
  margin-right: 0.75rem;
  font-size: 1.25rem;
  position: relative;
  z-index: 1;
}

.sidebar-link-notice :deep(.clr-i-badge) {
  fill: var(--bs-warning);
}

.nav-link.base-type-accommodations,
.nav-link.base-type-offers,
.nav-link.base-type-events,
.nav-link.base-type-discover {
  --sidebar-base-type-primary: var(--base-type-primary);
  --sidebar-base-type-secondary: var(--base-type-secondary);
  --sidebar-base-type-soft: var(--base-type-soft);
  --sidebar-base-type-border: var(--base-type-border);
  overflow: hidden;
}

.nav-link.base-type-accommodations::before,
.nav-link.base-type-offers::before,
.nav-link.base-type-events::before,
.nav-link.base-type-discover::before {
  content: "";
  position: absolute;
  inset: 0 auto 0 0;
  width: 0.25rem;
  background: var(--sidebar-base-type-primary);
  opacity: 1;
}

.nav-link.base-type-accommodations .sidebar-link-icon,
.nav-link.base-type-offers .sidebar-link-icon,
.nav-link.base-type-events .sidebar-link-icon,
.nav-link.base-type-discover .sidebar-link-icon {
  color: var(--sidebar-base-type-primary);
}

.nav-item-active > .nav-link.base-type-accommodations,
.nav-item-active > .nav-link.base-type-offers,
.nav-item-active > .nav-link.base-type-events,
.nav-item-active > .nav-link.base-type-discover,
.nav-link.base-type-accommodations:hover,
.nav-link.base-type-offers:hover,
.nav-link.base-type-events:hover,
.nav-link.base-type-discover:hover {
  border-color: var(--sidebar-base-type-primary);
  background: rgba(255, 255, 255, 0.08);
}

.sidebar-session {
  color: #ffffff;
  opacity: 0.9;
  font-size: 0.9rem;
}

.sidebar-link-hint-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-left: 0.5rem;
  padding: 0;
  border: 0;
  background: transparent;
  color: #f1b24a;
  opacity: 1;
  cursor: pointer;
  flex-shrink: 0;
  transition: transform 0.18s ease, color 0.18s ease;
}

.sidebar-link-hint-rocket {
  display: inline-flex;
  transform-origin: 50% 50%;
  position: relative;
}

.sidebar-link-hint-rocket--launch {
  animation: sidebar-rocket-launch 0.65s cubic-bezier(0.22, 1, 0.36, 1) !important;
}

.sidebar-link-hint-rocket::before,
.sidebar-link-hint-rocket::after {
  position: absolute;
  top: calc(100% - 0.05rem);
  left: 50%;
  width: 0.7rem;
  height: 0.7rem;
  opacity: 0;
  pointer-events: none;
  content: "";
}

.sidebar-link-hint-rocket::before {
  background:
    radial-gradient(circle, rgba(255, 248, 220, 0.98) 0 20%, rgba(255, 193, 95, 0.95) 21% 50%, rgba(255, 128, 55, 0.85) 51% 70%, transparent 71%);
}

.sidebar-link-hint-rocket::after {
  background:
    radial-gradient(circle, rgba(255, 255, 255, 0.96) 0 18%, rgba(255, 210, 110, 0.92) 19% 42%, rgba(255, 137, 61, 0.8) 43% 66%, transparent 67%);
}

.sidebar-link-hint-btn:hover,
.sidebar-link-hint-btn:focus-visible {
  color: #ffd37a;
  transform: translateY(-50%) scale(1.06);
}

.sidebar-link-hint-btn:hover .sidebar-link-hint-rocket,
.sidebar-link-hint-btn:focus-visible .sidebar-link-hint-rocket {
  animation: sidebar-rocket-hover 1.25s ease-in-out infinite;
}

.sidebar-link-hint-btn:hover .sidebar-link-hint-rocket--launch,
.sidebar-link-hint-btn:focus-visible .sidebar-link-hint-rocket--launch {
  animation: sidebar-rocket-launch 0.65s cubic-bezier(0.22, 1, 0.36, 1) !important;
}

.sidebar-link-hint-btn:hover .sidebar-link-hint-rocket::before,
.sidebar-link-hint-btn:focus-visible .sidebar-link-hint-rocket::before {
  animation: sidebar-rocket-thrust-a 0.75s ease-out infinite;
}

.sidebar-link-hint-btn:hover .sidebar-link-hint-rocket::after,
.sidebar-link-hint-btn:focus-visible .sidebar-link-hint-rocket::after {
  animation: sidebar-rocket-thrust-b 0.9s ease-out infinite;
}

.sidebar-link-disabled {
  cursor: default;
}

.sidebar-link-disabled-visual {
  opacity: 0.25;
}

.sidebar-link-hint-btn--overlay {
  position: absolute;
  top: 50%;
  right: 2.5rem;
  transform: translateY(-50%);
  z-index: 2;
}

.sidebar-link-hint-btn--nested {
  position: absolute;
  top: 50%;
  right: 1rem;
  transform: translateY(-50%);
  z-index: 2;
}

@keyframes sidebar-rocket-hover {
  0% {
    transform: translate3d(0, 0, 0) scale(1);
  }

  50% {
    transform: translate3d(0, -5px, 0) scale(1.03);
  }

  100% {
    transform: translate3d(0, 0, 0) scale(1);
  }
}

@keyframes sidebar-rocket-thrust-a {
  0% {
    opacity: 0;
    transform: translate(-50%, -20%) scale(0.25);
  }

  20% {
    opacity: 1;
  }

  100% {
    opacity: 0;
    transform: translate(-85%, 120%) scale(1.5);
  }
}

@keyframes sidebar-rocket-thrust-b {
  0% {
    opacity: 0;
    transform: translate(-50%, -20%) scale(0.2);
  }

  25% {
    opacity: 1;
  }

  100% {
    opacity: 0;
    transform: translate(-15%, 135%) scale(1.3);
  }
}

@keyframes sidebar-rocket-launch {
  0% {
    transform: translate3d(0, 0, 0) scale(1);
    opacity: 1;
  }

  35% {
    transform: translate3d(0, -140px, 0) scale(1.08);
    opacity: 0;
  }

  55% {
    transform: translate3d(0, 14px, 0) scale(0.96);
    opacity: 0;
  }

  80% {
    transform: translate3d(0, 0, 0) scale(1);
    opacity: 0.55;
  }

  100% {
    transform: translate3d(0, 0, 0) scale(1);
    opacity: 1;
  }
}
</style>
